<template>
    <v-display :form="form" :path="path" :label="topLabel" value="" :hide-underline="hideUnderline">
        <q-checkbox v-model="inputValue"
                    :label="bottomLabel | capitalize"
                    :color="color"
                    :disable="form.busy || disable"
                    checked-icon="check box"
                    :dusk="path"
                    :test-id="path"
                    unchecked-icon="check_box_outline_blank"
                    @input="onInput"></q-checkbox>
    </v-display>
</template>

<script>
    import mixins from './mixins'
    import {QCheckbox} from 'quasar-framework'

    export default {
        name: 'VCheckbox',

        mixins,

        data() {
            return {
                inputValue: this.value ? true : false
            }
        },

        props: {
            innerLabel: String
        },

        computed: {
            topLabel() {
                return this.innerLabel ? this.label : ''
            },
            bottomLabel() {
                return this.innerLabel || this.label
            },
        },

        components: {
            QCheckbox
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/form/VCheckbox.vue